var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel__tab"},[_c('div',{staticClass:"name",attrs:{"data-icoTarget":_vm.valueIco},on:{"click":function($event){return _vm.$emit('togglePanel')}}},[_vm._v(" "+_vm._s(_vm.title)+" "),_vm._m(0)]),_vm._t("default")],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icoButton__options"},[_c('div',{staticClass:"icoButton icoButton__downUp",attrs:{"data-icoTarget":"up"}})])
}]

export { render, staticRenderFns }